/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the case
 * @export
 */
export const ControlStatus2 = {
    New: 'NEW',
    Processing: 'PROCESSING',
    Escalated: 'ESCALATED',
    Hunting: 'HUNTING',
    Monitoring: 'MONITORING',
    Chatops: 'CHATOPS',
    Closed: 'CLOSED'
} as const;
export type ControlStatus2 = typeof ControlStatus2[keyof typeof ControlStatus2];


export function ControlStatus2FromJSON(json: any): ControlStatus2 {
    return ControlStatus2FromJSONTyped(json, false);
}

export function ControlStatus2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStatus2 {
    return json as ControlStatus2;
}

export function ControlStatus2ToJSON(value?: ControlStatus2 | null): any {
    return value as any;
}

